import html2canvas from 'html2canvas'
import * as echarts from 'echarts'
import {Kenya} from '../../maps'

let storeContent = utils.generateStore({
   projectsCount: 0,
   updatedObjectivesCount: 0,
   usersCount: 0,
   options: {
      shortcuts: [
         {
            text: 'Last week',
            value () {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
               return [start, end];
            }
         },
         {
            text: '30 Days',
            value () {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
               return [start, end];
            }
         },
         {
            text: '60 Days',
            value () {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
               return [start, end];
            }
         },
         {
            text: '90 Days',
            value () {
               const end = new Date();
               const start = new Date();
               start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
               return [start, end];
            }
         }
      ]
   },
   objectivesThisWeek: 0,
   objectivesLastWeek: 0,
   objectivesUpdateChart: null,
   main_dashboard_id: null,
   chartOptions: {},
   filter_map: {},
   visuals: [],
   filters: [],
   dashboard_filters: [],
   date: [
      moment().subtract(7,'days').format('DD-MM-YYYY'),
      moment().format('DD-MM-YYYY'),
   ],
   toolbox: {
      feature: {
         
      }
   }
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      generateDataAndColors(ctx,payload){
         let colors = ['#007041','#bf121a','#FE9A01', '#3366CC','#981D99','#0099C6','#e377c2', '#f7b6d2', '#7f7f7f', '#c7c7c7', '#bcbd22', '#dbdb8d', '#17becf', '#9edae5'], data = []

         for (let i = 0; i < payload.values.length; i++) {
            const val = payload.values[i];
            
            if(payload.visual.type === 'pie' || payload.visual.type === 'doughnut'){
               if(val >= 1){
                  data.push({value: val, name: payload.labels[i]})
               }
            }
            if(i > colors.length){
               colors.push(colors[i-colors.length])
            }
         }

         return {colors,data}
      },
      getToolbox(ctx,payload){
         try {
            return {
               // show: true,
               // feature: {
               //    saveAsImage: {show: true, title: "Save"},
                  // myFull: {
                  //    show: true,
                  //    title: 'Full',
                  //    icon: 'http://uat-apis.futurefast.co.ke:3050/favicon.svg',
                  //    onclick: () => {
                  //       const element = document.getElementById(payload.lineId);

                  //       if (window.ActiveXObject) {
                  //          const WsShell = new ActiveXObject('WScript.Shell');
                  //          WsShell.SendKeys('{F11}');
                  //       } else if (element.requestFullScreen) {// HTML W3C proposed
                  //          element.requestFullScreen();
                  //       } else if (element.msRequestFullscreen) { // IE11
                  //          element.msRequestFullScreen();
                  //       } else if (element.webkitRequestFullScreen) { // Webkit (works in Safari5.1 and Chrome 15)
                  //          element.webkitRequestFullScreen();
                  //       } else if (element.mozRequestFullScreen) { // Firefox (works in nightly)
                  //          element.mozRequestFullScreen();
                  //       }
                  //    },
                  // },
               // },
               // top: -5
            }
         } catch (err) {
            throw err
         }
      },
      getTooltip(ctx,type){
         try {
            if(type === 'line'){
               return {
                  trigger: 'item',
                  // position: ['0','50%'],
                  position: 'nearest',
                  textStyle: {
                     font: 'source-sans-pro,sans-serif',
                     fontSize: 12
                  }
               }
            }else if(type === 'calendar'){
               return {
                  trigger: 'item',
                  formatter: '<b>{c}</b>',
                  position: ['0','50%'],
                  textStyle: {
                     font: 'source-sans-pro,sans-serif',
                     fontSize: 12
                  }
               }
            }else if(type === 'pie' || type === 'doughnut'){
               return {
                  trigger: 'item',
                  formatter: '<b>{a}</b> <br/><b>{b}</b> : <b>{c}</b> ({d}%)',
                  position: 'nearest',
                  textStyle: {
                     font: 'source-sans-pro,sans-serif',
                     fontSize: 12
                  }
               }
            }else{
               return {
                  trigger: 'item',
                  formatter: '<b>{a}</b> <br/><b>{b}</b> : <b>{c}</b> ({d}%)',
                  position: ['0','50%'],
                  // position: 'nearest',
                  textStyle: {
                     font: 'source-sans-pro,sans-serif',
                     fontSize: 12
                  }
               }
            }
         } catch (err) {
            throw err
         }
      },
      async downloadChart(ctx,payload){
         try {

            payload.ref[0].style.boxShadow = 'none'
            const printCanvas = await html2canvas(payload.ref[0], {
               type: "dataURL",
               scrollX: -window.scrollX,
               scrollY: -window.scrollY,
               windowWidth: window.innerWidth,
               windowHeight: payload.ref[0].offsetHeight,
               scale: 0.9
            });

            const link = document.createElement("a");
            link.setAttribute("download", `${payload.name}-${ctx.getters.date[0]}-${ctx.getters.date[1]}.png`);
            link.setAttribute("href", printCanvas.toDataURL("image/png").replace("image/png", "image/octet-stream"));
            link.click();
            payload.ref[0].style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)'
         } catch (err) {
            throw err
         }
      },
      async downloadChartReport(ctx,payload){
         try {
            const printCanvas = await html2canvas(document.querySelector('.dashboard'), {
               type: "dataURL",
               scale: 0.9
            });

            const link = document.createElement("a");
            link.setAttribute("download", `${payload.name}-report-${ctx.getters.date[0]}-${ctx.getters.date[1]}.png`);
            link.setAttribute("href", printCanvas.toDataURL("image/png").replace("image/png", "image/octet-stream"));
            link.click();
         } catch (err) {
            throw err
         }
      },
      generateSeries(ctx,payload){
         try {
            let series = [], areaStyle = undefined, _series = null

            if(payload.visual.type === 'area'){
               areaStyle = {}
            }

            let i = 0
            for (const [key,val] of Object.entries(payload.values)) {
               let markPoint = {
                  data: [
                     {
                        label: {
                           position: 'start',
                           formatter: '最大值'
                        },
                        type: 'max',
                        name: 'Maximum'
                     },
                     {
                        label: {
                           position: 'start',
                           formatter: '最大值'
                        },
                        type: 'min',
                        name: 'Minimum'
                     },
                  ]
               }

               if(payload.visual.type === 'area'){
                  _series = {
                     name: key,
                     type: 'line',
                     data: val,
                     smooth: true,
                     symbol: 'circle',
                     itemStyle: {normal: {areaStyle: {type: 'default'}}},
                  }
               }else if(payload.visual.type === 'bar'){
                  _series = {
                     name: key,
                     type: 'bar',
                     data: val,
                     animationDelay: function (idx) {
                        return idx * 10 + (i*100);
                     }
                  }
               }else{
                  _series = {
                     name: key,
                     type: 'line',
                     data: val,
                     smooth: true,
                     symbol: 'circle',
                  }
               }

               if(payload.visual.stacked){
                  _series.stack = '总量'
               }
               // _series.markPoint = markPoint
               series.push(_series)
               i++
            }

            return series
         } catch (err) {
            throw err
         }
      },
      async createBarChart(ctx,payload){
         let chartOptions = ctx.getters.chartOptions, {colors,data} = await ctx.dispatch('generateDataAndColors',payload)
         payload.colors = colors

         chartOptions[payload.lineId] = {
            tooltip: await ctx.dispatch('getTooltip','line'),
            legend: {
               data: Object.keys(payload.values),
            },
            toolbox: await ctx.dispatch('getToolbox',payload),
            xAxis: {
               type: 'category',
               boundaryGap: false,
               boundaryGap: [0, '50%'],
               data: payload.labels
            },
            yAxis: {
               type: 'value',
               boundaryGap: [0, '100%']
            },
            // dataZoom: [{
            //       type: 'inside',
            //       start: 0,
            //       end: 50
            //    }, {
            //       start: 0,
            //       end: 50,
            //       handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
            //       handleSize: '80%',
            //       handleStyle: {
            //          color: '#fff',
            //          shadowBlur: 3,
            //          shadowColor: 'rgba(0, 0, 0, 0.6)',
            //          shadowOffsetX: 2,
            //          shadowOffsetY: 2
            //       }
            //    }
            // ],
            series: await ctx.dispatch('generateSeries',payload),
            color:colors,
            animationEasing: 'elasticOut',
            animationDelayUpdate: function (idx) {
               return idx * 5;
            }
         };

         if(payload.visual.orientation && payload.visual.orientation === 'horizontal'){
            chartOptions[payload.lineId].xAxis = {
               type: 'value',
               boundaryGap: [0, '100%']
            }

            chartOptions[payload.lineId].yAxis = {
               type: 'category',
               data: payload.labels,
               // nameTextStyle: {
               //    fontSize: 9,
               //    color: 'red'
               // }
            }
         }
         ctx.commit('chartOptions',chartOptions)
		},
      async createLineChart(ctx,payload){
         let chartOptions = ctx.getters.chartOptions, {colors,data} = await ctx.dispatch('generateDataAndColors',payload)
         payload.colors = colors

         chartOptions[payload.lineId] = {
            tooltip: await ctx.dispatch('getTooltip','line'),
            legend: {
               data: Object.keys(payload.values)
            },
            toolbox: await ctx.dispatch('getToolbox',payload),
            xAxis: {
               type: 'category',
               boundaryGap: false,
               data: payload.labels
            },
            yAxis: {
               type: 'value',
               boundaryGap: [0, '50%']
            },
            series: await ctx.dispatch('generateSeries',payload),
            color:colors
         };

         ctx.commit('chartOptions',chartOptions)
		},
      async createPieChart(ctx,payload){
         let chartOptions = ctx.getters.chartOptions, {colors,data} = await ctx.dispatch('generateDataAndColors',payload)

         chartOptions[payload.lineId] = {
            tooltip: await ctx.dispatch('getTooltip','pie'),
            toolbox: await ctx.dispatch('getToolbox',payload),
            series: [
               {
                  name: payload.visual.name,
                  type: 'pie',
                  radius: '55%',
                  roseType: 'angle',
                  itemStyle: {
                     emphasis: {
                        shadowBlur: 200,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                     }
                  },
                  data,
               }
            ],
            color:colors
         };

         ctx.commit('chartOptions',chartOptions)
		},
      async createCalendarChart(ctx,payload){
         let chartOptions = ctx.getters.chartOptions

         chartOptions[payload.lineId] = {
            tooltip: await ctx.dispatch('getTooltip','calendar'),
            toolbox: await ctx.dispatch('getToolbox',payload),
            visualMap: {
               // show: false,
               min: 0,
               max: payload.max,
               text: ['High', 'Low'],
               calculable: true,
               orient: 'horizontal',
               right: 0,
               bottom: 0
            },
            calendar: {
               range: payload.year
            },
            series: {
               type: 'heatmap',
               coordinateSystem: 'calendar',
               data: payload.data
            },
            // color:colors
         };

         ctx.commit('chartOptions',chartOptions)
		},
      async createCalendarWeek(ctx,payload){
         let chartOptions = ctx.getters.chartOptions
         let hours = [
            '12a', '1a', '2a', '3a', '4a', '5a', '6a','7a', '8a', '9a','10a','11a','12p', '1p', '2p', '3p', '4p', '5p','6p', '7p', '8p', '9p', '10p', '11p'
         ], days = [
            'Saturday', 'Friday', 'Thursday', 'Wednesday', 'Tuesday', 'Monday', 'Sunday'
         ];

         chartOptions[payload.lineId] = {
            tooltip: await ctx.dispatch('getTooltip','calendar'),
            toolbox: await ctx.dispatch('getToolbox',payload),
            xAxis: {
               type: 'category',
               data: hours,
               splitArea: {
                  show: true
               }
            },
            yAxis: {
               type: 'category',
               data: days,
               splitArea: {
                  show: true
               }
            },
            visualMap: {
               min: 0,
               max: payload.max,
               calculable: true,
               orient: 'horizontal',
               left: 'center',
            },
            series: {
               name: 'Punch Card',
               type: 'heatmap',
               data: payload.data,
               label: {
                     show: true
               },
               emphasis: {
                     itemStyle: {
                        shadowBlur: 10,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                     }
               }
            },
            // color:colors
         };

         ctx.commit('chartOptions',chartOptions)
		},
      async createHamburgerChart(ctx,payload){
         let chartOptions = ctx.getters.chartOptions, {colors,data} = await ctx.dispatch('generateDataAndColors',payload)

         chartOptions[payload.lineId] = {
            tooltip: await ctx.dispatch('getTooltip','doughnut'),
            toolbox: await ctx.dispatch('getToolbox',payload),
            series: [
               {
                  name: payload.visual.name,
                  type: 'pie',
                  radius: [30, 110],
                  roseType: 'area',
                  data
               }
            ],
            color:colors
         };

         ctx.commit('chartOptions',chartOptions)
		},
      async createRegionChart(ctx,payload){
         let chartOptions = ctx.getters.chartOptions

         echarts.registerMap(payload.visual.country, Kenya, {});
         chartOptions[payload.lineId] = {
            // tooltip: await ctx.dispatch('getTooltip','calendar'),
            toolbox: await ctx.dispatch('getToolbox',payload),
            tooltip: {
                  trigger: 'item',
                  showDelay: 0,
                  transitionDuration: 0.2,
                  formatter: function (params) {
                     var value = (params.value + '').split('.');
                     value = value[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,');
                     return params.seriesName + '<br/>' + params.name + ': ' + value;
                  }
            },
            visualMap: {
               left: 'right',
               min: 0,
               max: payload.max,
               inRange: {
                  color: ['#bf121a', '#FE9A01', '#007041']
               },
               text: ['High', 'Low'],
               calculable: true
            },
            legend: [
               {
                  selectedMode: "multiple",
                  top: "top",
                  orient: "horizontal",
                  data: [""],
                  left: "center",
                  show: true,
               },
            ],
            backgroundColor: "#fff",
            series: [
               {
                  data: payload.data,
                  name: "",
                  symbol: "circle",
                  type: "map",
                  map: 'Kenya',
                  roam: true,
               },
            ],
         };

         ctx.commit('chartOptions',chartOptions)
		},
      async fetchVisuals(ctx){
         try {
            let range = ctx.getters.date
            ctx.commit('visuals',generateVisuals(moment(range[0],'DD-MM-YYYY'),moment(range[1],'DD-MM-YYYY')));
         } catch (err) {
            throw err
         }
      },
      async fetchData(ctx,payload){
         try {
            ctx.commit('loading',true)
            if(!payload){
               payload = {
                  type: 'main'
               }
            }

            if(payload.date){
               ctx.commit('date',payload.date)
            }
            await ctx.dispatch('fetchVisuals')
            await ctx.dispatch('createChart')
            ctx.commit('loading',false)
            Event.$emit('loader:show',false)
         } catch (err) {
            ctx.commit('loading',false)
            throw err
         }
      },
      async createChart(ctx){
         try {
            for (const visual of ctx.getters.visuals) {
               if(visual.type === 'line' || visual.type === 'area'){
                  await ctx.dispatch('createLineChart',{
                     visual,
                     labels: visual.data.labels,
                     values: visual.data.values,
                     lineId: visual.name.toLowerCase().split(' ').join('_')
                  })
               }else if(visual.type === 'map'){
                  await ctx.dispatch('createMap',{
                     data: visual.data.data,
                     markers: visual.data.markers,
                     mapId: visual.name.toLowerCase().split(' ').join('_')
                  })
               }else if(visual.type === 'pie'){
                  await ctx.dispatch('createPieChart',{
                     visual,
                     labels: visual.data.labels,
                     values: visual.data.values,
                     lineId: visual.name.toLowerCase().split(' ').join('_')
                  })
               }else if(visual.type === 'doughnut'){
                  await ctx.dispatch('createHamburgerChart',{
                     visual,
                     labels: visual.data.labels,
                     values: visual.data.values,
                     lineId: visual.name.toLowerCase().split(' ').join('_')
                  })
               }else if(visual.type === 'bar'){
                  await ctx.dispatch('createBarChart',{
                     visual,
                     labels: visual.data.labels,
                     values: visual.data.values,
                     lineId: visual.name.toLowerCase().split(' ').join('_')
                  })
               }else if(visual.type === 'calendar'){
                  await ctx.dispatch('createCalendarChart',{
                     visual,
                     year: visual.data.year,
                     data: visual.data.data,
                     max: visual.data.max,
                     lineId: visual.name.toLowerCase().split(' ').join('_')
                  })
               }else if(visual.type === 'calendar_week'){
                  await ctx.dispatch('createCalendarWeek',{
                     visual,
                     data: visual.data.data,
                     max: visual.data.max,
                     lineId: visual.name.toLowerCase().split(' ').join('_')
                  })
               }else if(visual.type === 'region_map'){
                  await ctx.dispatch('createRegionChart',{
                     visual,
                     data: visual.data.data,
                     max: visual.data.max,
                     lineId: visual.name.toLowerCase().split(' ').join('_')
                  })
               }
            }
         } catch (err) {
            throw err
         }
      },
      async createOneChart(ctx,data){
         try {
            console.log('Creating One Chart')
            for (let i = 0; i < ctx.getters.visuals.length; i++) {
               let visual = {data: data.data,...data.visual}
               
               if(ctx.getters.visuals[i]._id === visual._id){
                  visual.is_loading = false
                  ctx.getters.visuals[i] = visual
                  ctx.commit('visuals',ctx.getters.visuals)
                  
                  if(visual.type === 'line' || visual.type === 'area'){
                     await ctx.dispatch('createLineChart',{
                        visual,
                        labels: visual.data.labels,
                        values: visual.data.values,
                        lineId: visual.name.toLowerCase().split(' ').join('_')
                     })
                  }else if(visual.type === 'map'){
                     await ctx.dispatch('createMap',{
                        data: visual.data.data,
                        markers: visual.data.markers,
                        mapId: visual.name.toLowerCase().split(' ').join('_')
                     })
                  }else if(visual.type === 'pie'){
                     await ctx.dispatch('createPieChart',{
                        visual,
                        labels: visual.data.labels,
                        values: visual.data.values,
                        lineId: visual.name.toLowerCase().split(' ').join('_')
                     })
                  }else if(visual.type === 'doughnut'){
                     await ctx.dispatch('createHamburgerChart',{
                        visual,
                        labels: visual.data.labels,
                        values: visual.data.values,
                        lineId: visual.name.toLowerCase().split(' ').join('_')
                     })
                  }else if(visual.type === 'bar'){
                     await ctx.dispatch('createBarChart',{
                        visual,
                        labels: visual.data.labels,
                        values: visual.data.values,
                        lineId: visual.name.toLowerCase().split(' ').join('_')
                     })
                  }else if(visual.type === 'calendar'){
                     await ctx.dispatch('createCalendarChart',{
                        visual,
                        year: visual.data.year,
                        data: visual.data.data,
                        max: visual.data.max,
                        lineId: visual.name.toLowerCase().split(' ').join('_')
                     })
                  }else if(visual.type === 'calendar_week'){
                     await ctx.dispatch('createCalendarWeek',{
                        visual,
                        data: visual.data.data,
                        max: visual.data.max,
                        lineId: visual.name.toLowerCase().split(' ').join('_')
                     })
                  }else if(visual.type === 'region_map'){
                     await ctx.dispatch('createRegionChart',{
                        visual,
                        data: visual.data.data,
                        max: visual.data.max,
                        lineId: visual.name.toLowerCase().split(' ').join('_')
                     })
                  }
               }
            }

            ctx.commit('visuals',ctx.getters.visuals)
            Event.$emit('component:reload',true)
         } catch (err) {
            throw err
         }
      },
      async parseData(ctx,data){
         try {
            let str = ''
            for (const [key,val] of Object.entries(data)) {
               if(val.location){
                  str += `<div class="cont"><div class="info-title">Coordinates</div><div class="info-data">[${val.location.lat.lat},${val.location.lat.lng}]</div></div>`
               }else{
                  str += `<div class="cont"><div class="info-title">${key}</div><div class="info-data">${val}</div></div>`
               }
            }

            return `<div class="window-cont">${str}</div>`
         } catch (err) {
            throw err
         }
      },
      async createMap(ctx,payload){
         try {
            let map = new google.maps.Map(document.getElementById(payload.mapId), {
               zoom: 3,
               controlSize: 22,
               // center: new google.maps.LatLng(payload.markers[0].lat, payload.markers[0].lng),
               styles: utils.getMapStyles()
            }),allMarkers = [];

            // Initialize only when there are markers present
            if(payload.markers.length > 0){
               for (const mark of payload.markers) {
                  let lat = Number(mark.lat)
   
                  if(lat <= 82 && lat >= -82){
                     let marker = null
      
                     const infowindow = new google.maps.InfoWindow({
                        content: await ctx.dispatch('parseData',mark.data),
                     });
                     marker = new google.maps.Marker({
                        position: new google.maps.LatLng(lat,Number(mark.lng)),
                        map: map
                     });
                     marker.addListener("click", () => {
                        infowindow.open(map, marker);
                     });
                     allMarkers.push(marker)
                  }
               }
               
               new MarkerClusterer(map, allMarkers, {
                  imagePath:"https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
               });
               map.setCenter(new google.maps.LatLng(Number(payload.markers[0].lat),Number(payload.markers[0].lng)))
            }
         } catch (err) {
            throw err
         }
      },
      async fetchMainDashboardData(ctx){
         try {
            if(!ctx.getters.main_dashboard_id){
               let res = await api.fetchEndpointSecure({
                  resource: 'commons',
                  action: 'list',
                  data: { 
                     rules: {
                        match: {
                           is_main_dashboard: true
                        }
                     }
                  },
                  meta_data: {service: "analytics", collection: "dashboard"}
               })

               if(res.result.records.length > 0){
                  ctx.commit('main_dashboard_id',res.result.records[0]._id)
               }
            }

            if(ctx.getters.main_dashboard_id){
               await ctx.dispatch('fetchDashboardVisuals',ctx.getters.main_dashboard_id)
            }
            Event.$emit('loader:show',false)
         } catch (err) {
            throw err
         }
      },
      async fetchDashboardVisuals(ctx,dashboard_id){
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'dashboard',
               action: 'get:visuals',
               data: { dashboard_id },
               meta_data: {}
            })

            let visuals = res.result.visuals
            ctx.commit('filters',res.result.filters)
            for (let i = 0; i < visuals.length; i++) {
               const visual = visuals[i];
               visual = await ctx.dispatch('generateVisuals',visual)
               ctx.dispatch('fetchVisual',{visual_id: visual._id,count: i})
            }

            let filter_map = {}
            for (let i = 0; i < ctx.getters.filters.length; i++) {
               const filter = ctx.getters.filters[i];
               
               if(filter.type === 'number'){
                  filter_map[filter.field] = {
                     selected_option: '',
                     selected_value: 0,
                  }
               }else{
                  filter_map[filter.field] = {
                     selected_option: []
                  }
               }

               filter_map[filter.field].table = filter.table
               filter_map[filter.field].field = filter.field
               filter_map[filter.field].type = filter.type
            }

            ctx.commit('filter_map', filter_map);
            ctx.commit('visuals', res.result.visuals);
            Event.$emit('loader:show',false)
         } catch (err) {
            throw err
         }
      },
      async fetchVisual(ctx,{visual_id,count}){
         try {
            let res = await api.fetchEndpointSecureRefresh({
               resource: 'visualization',
               action: 'get:visual',
               data: { 
                  visual_id,
                  date_filter: {
                     from: moment(`${ctx.getters.date[0]} 00:00:00`,'DD-MM-YYYY HH:mm:SS'),
                     to: moment(`${ctx.getters.date[1]} 23:59:59`,'DD-MM-YYYY HH:mm:SS'),
                  },
                  filters: ctx.getters.dashboard_filters
               },
               meta_data: {}
            })

            let result = res.result, values = {}
            if(result?.visual?.orientation && result?.visual?.orientation === 'horizontal' && result?.visual.type && ['line','bar','area'].includes(result.visual.type) && Object.keys(result.data.values).length > result.visual.limit){
               let keys = Object.keys(result.data.values)

               for (let i = 0; i < result.visual.limit; i++) {
                  const key = keys[i];
                  values[key] = result.data.values[key]
               }
               
               result.data.values = values
            }
            await ctx.dispatch('createOneChart',result)
         } catch (err) {
            throw err
         }
      },
      async generateVisuals(ctx,visual){
         try {
            visual.is_loading = true
            let line_data = []

            if(visual.type === 'stat_card'){
               visual.data = {
                  count: 307462,
                  last_count: 2054,
                  difference: 305408,
                  difference_percentage: 99.33
               }
            }else if(['pie','doughnut'].includes(visual.type)){
               visual.data = { 
                  labels: ['Label A','Label B','Label C','Label D'],
                  values: [200,120,80,20]
               }
            }else if(['bar','line','area'].includes(visual.type)){
               visual.data = { 
                  labels: ["02-03","03-03","04-03","05-03","06-03","08-03","09-03","10-03","11-03","12-03","15-03","16-03"],
                  values: {
                     "Label A": [3550,5,4190,40,1310,3517,434,0,40,1342,138,37],
                     "Label B": [0,0,0,0,2000,36,18,0,8,16,16,4],
                     "Label C": [0,400,0,0,1000,360,180,0,8000,160,160,4000],
                  }
               }
            }else if(['calendar'].includes(visual.type)){
               visual.data = {
                  data: [
                     [ "09-03-2021", 434],[ "08-03-2021", 3517],[ "06-03-2021", 1310],[ "02-03-2021", 715873550],[ "12-03-2021", 1342],[ "15-03-2021", 138],[ "16-03-2021", 37],[ "03-03-2021", 5],[ "11-03-2021", 40],[ "05-03-2021", 40],[ "04-03-2021", 4190],[ "10-03-2021", 100]
                  ],
                  max: 1310,
                  year: 2021,
               }
            }else if(['calendar_week'].includes(visual.type)){
               visual.data = {
                  data: [
                     [0,0,5],[0,1,1],[0,2,0],[0,3,0],[0,4,0],[0,5,0],[0,6,0],[0,7,0],[0,8,0],[0,9,0],[0,10,0]
                  ],
                  max: 20,
               }
            }

            return visual
         } catch (err) {
            throw err
         }
      }
   }
};